module.exports = __webpack_public_path__ + "static/cities-delight-2_2-db3b6192e2eec0c0020652f4bcbd41c0.jpg";